class LoadingButton extends HTMLElement {
  constructor() {
    super();
    this.url = "";
    this.totalProducts = 0;
    this.loadedProducts = 0;
    this.loadPrevious = this.dataset.load === "previous";
    if (!this.loadPrevious) {
      this.progressBar = this.querySelector(".progress-bar");
      this.progressBar.value = this.loadedProducts;
      this.resultCount = this.querySelector(".result-count");
      this.productContainer = document.querySelector("#product-grid");
    }
    this.automaticLoading = this.getAttribute("automatic-loading");
    this.loadButton = this.querySelector("button");
    this.loadButtonContainer = this.closest(".pagination-wrapper");
    this.articleContainer = document.querySelector("#article-grid");
    this.vanillaPagination = document.querySelector("#pagination");
    if (!this.loadPrevious) {
      this.loadButton.addEventListener("click", () => {
        this.loadMore();
      });
    }
    document.addEventListener('click', this.gridItemLinkInterceptor.bind(this));
    if (this.automaticLoading === true) {
      // loading observer
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.25,
      };
      this.observer = new IntersectionObserver(this.handleIntersection, options);
    }
  }

  connectedCallback() {
    if (this.automaticLoading === "true") {
      this.observer.observe(this.loadButton);
    }
    this.loadedProducts = parseInt(this.loadButton.getAttribute("data-loaded-products-total"));
    this.totalProducts = parseInt(this.loadButton.getAttribute("data-total-results-count"));
    this.updateProgress();
  }

  setLastVisitedProductInSessionStorage(variantID, collectionHandle) {
    sessionStorage.setItem("lastVisitedProduct", JSON.stringify({ variantID, collectionHandle }));
  }

  // intercepts product card and article card links and updates the url with the page number
  gridItemLinkInterceptor(e) {

    if (e.target.closest('quickbuy-button') || e.target.closest('product-form') || e.target.closest('.product-card__wishlist-button')) {
      return;
    } else if (e.target.closest('product-card') && e.target.closest('#product-grid')) {
      e.preventDefault();
      const variantID = e.target.closest('li.grid__item').dataset.variantId;
      const collectionHandle = e.target.closest('#product-grid').dataset.collectionHandle;
      this.setLastVisitedProductInSessionStorage(variantID, collectionHandle);

      let url = new URL(window.location.href);
      let page = e.target.closest('li.grid__item').dataset.pageIndex;
      url.searchParams.set("page", page);
      window.history.pushState({ path: url.href }, '', url.href);
      window.location.href = e.target.closest('product-card').querySelector('a').href;
    } else if (e.target.closest('.article-card-wrapper') && e.target.closest('#article-grid')) {
      e.preventDefault();
      let url = new URL(window.location.href);
      let page = e.target.closest('.blog-articles__article').dataset.pageIndex;
      url.searchParams.set("page", page);
      window.history.pushState({ path: url.href }, '', url.href);
      window.location.href = e.target.closest('.blog-articles__article').dataset.url;
    } else {
      return;
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        entry.target.closest("loading-button").loadMore();
      }
    });
  }

  loadMore() {
    this.url = document.querySelector(".pagination-wrapper a.pagination__item--next").href;
    this.loadButton.classList.add("loading");
    this.loadButton.querySelector(".loading-overlay__spinner").classList.remove("hidden");
    this.fetchItems(this.url);
  }

  fetchItems(url, loadPrevious) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        if (url.includes("blog")) {
          this.renderArticleGrid(html, loadPrevious);
          window.history.pushState({}, "", url);
          if (!loadPrevious) {
            this.renderNewNavigation(html);
          }
          this.loadingButtonChecker();
        } else {
          window.history.pushState({}, "", url);

          const parser = new DOMParser();
          const doc = parser.parseFromString(responseText, "text/html");

          this.updateCanonicalLink(doc);
          this.updateHrefLangs(doc);
          this.renderProductGrid(html);
          this.renderNewNavigation(html);
          this.loadingButtonChecker();
          this.updateProgress();

          const LayoutToggle = document.querySelector("layout-toggle");
          if (LayoutToggle) {
            LayoutToggle.hideOverhangingProducts();
          }

          // Datalayer tracking
          document.dispatchEvent(new CustomEvent("update-tracking-buttons"));
        }
      });
  }

  updateHrefLangs(doc) {
    const hrefLangs = doc.querySelectorAll('link[rel="alternate"]');
    const head = document.querySelector("head");

    hrefLangs.forEach((hrefLang) => {
      const lang = hrefLang.getAttribute("hreflang");
      const href = hrefLang.getAttribute("href");
      const existingHrefLang = head.querySelector(`link[hreflang="${lang}"]`);

      if (existingHrefLang) {
        existingHrefLang.setAttribute("href", href);
      } else {
        head.appendChild(hrefLang);
      }
    });
  }

  updateCanonicalLink(doc) {
    const canonicalLink = doc.querySelector('link[rel="canonical"]');
    const head = document.querySelector("head");
    const existingCanonicalLink = head.querySelector('link[rel="canonical"]');

    if (existingCanonicalLink) {
      existingCanonicalLink.setAttribute("href", canonicalLink.getAttribute("href"));
    } else {
      head.appendChild(canonicalLink);
    }
  }

  renderProductGrid(html) {
    // Trust pilot reviews fix - ensures reviews are loaded for previous cards
    const trustPilotReviews = this.productContainer.querySelectorAll(".trustpilot-widget");
    trustPilotReviews.forEach((review) => (review.innerHTML = ""));

    let newPage = new DOMParser().parseFromString(html, "text/html").getElementById("product-grid").innerHTML;
    this.productContainer.innerHTML = this.productContainer.innerHTML + newPage;
    this.loadedProducts = this.productContainer.querySelectorAll(".product").length;
    buildFeaturedCSS();

    this.renderWishlistButtons();
    this.renderTrustPilotBadges();
  }

  renderWishlistButtons() {
    let productGridSelector = "main #product-grid";

    document.dispatchEvent(
      new CustomEvent("swym:refresh-products", {
        detail: {
          selector: productGridSelector,
        },
      })
    );
  }

  renderTrustPilotBadges() {
    document.dispatchEvent(
      new CustomEvent("trustpilot:render-product-mini-widgets", {
        detail: {
          productContainerSelector: "main #product-grid",
        },
      })
    );
  }

  renderArticleGrid(html, loadPrevious) {
    let newPage = new DOMParser().parseFromString(html, "text/html").getElementById("article-grid").innerHTML;
    if (loadPrevious) {
      this.articleContainer.innerHTML = newPage + this.articleContainer.innerHTML;
    } else {
      this.articleContainer.innerHTML = this.articleContainer.innerHTML + newPage;
    }
    this.loadedArticles = this.articleContainer.querySelectorAll(".article").length;
  }

  renderNewNavigation(html) {
    const newPagination = new DOMParser().parseFromString(html, "text/html").getElementById("pagination")?.innerHTML;
    if (newPagination) {
      this.vanillaPagination.innerHTML = newPagination;
    } else {
      this.loadButtonContainer.innerHTML = "";
    }
  }

  loadingButtonChecker() {
    this.loadButton.classList.remove("loading");
    this.loadButton.querySelector(".loading-overlay__spinner").classList.add("hidden");

    const urlParams = new URLSearchParams(window.location.search);
    const pageIndex = parseInt(urlParams.get("page"));

    const directionLength = !this.loadPrevious ? document.querySelectorAll(".pagination-wrapper a.pagination__item--next").length : pageIndex;
    if (this.loadPrevious && pageIndex === 1) {
      this.classList.add("hidden");
      return;
    }

    if (directionLength === 0) {
      this.loadButtonContainer.classList.add("hidden");
      const LayoutToggle = document.querySelector("layout-toggle");
      if (LayoutToggle) {
        LayoutToggle.showAllProducts();
      }
    }
  }

  updateProgress() {
    let visibleProducts = document.querySelectorAll("#product-grid > li:not(.hidden,.featured-card)");
    let progress = (visibleProducts.length / this.totalProducts) * 100;
    this.progressBar.setAttribute("style", "--progress:" + `${progress}` + "%");
    this.resultCount.textContent = this.resultCount.dataset.textTemplate.replace("[LOADED]", visibleProducts.length).replace("[TOTAL]", this.totalProducts);
  }
}

customElements.define("loading-button", LoadingButton);

class LoadPreviousProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", this.loadPrevious.bind(this));
    document.addEventListener("previous-items-loaded", this.updateLoadMoreProgressCount.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener("previous-items-loaded", this.updateLoadMoreProgressCount.bind(this));
  }

  updateLoadMoreProgressCount() {
    let loadMoreButton = document.querySelector("loading-button");
    let loadedProducts = parseInt(loadMoreButton.getAttribute("data-loaded-products-total"));
    let newLoadedProducts = this.prevProductContainer.querySelectorAll(".product").length;

    loadMoreButton.setAttribute("data-loaded-products-total", loadedProducts + newLoadedProducts);
    loadMoreButton.updateProgress();
  }

  getPreviousPageIndex() {
    let previousPageIndex = parseInt(this.pageIndex) - 1;

    if (previousPageIndex <= 1) {
      return 1;
    } else {
      return previousPageIndex;
    }
  }

  loadPrevious() {
    this.classList.add("loading");
    this.querySelector(".loading-overlay__spinner")?.classList.remove("hidden");

    this.pageIndex = this.dataset.pageIndex;

    let url = window.location.href;
    let params = new URLSearchParams(window.location.search);
    let previousPageIndex = this.getPreviousPageIndex();

    params.set("page", previousPageIndex);

    window.history.pushState({}, "", `${url.split("?")[0]}?${params.toString()}`);

    document.querySelector("facets-filters-form")?.getPreviousData();

    this.dataset.pageIndex = previousPageIndex;
  }
}

customElements.define("load-previous-products", LoadPreviousProducts);

class LoadingPreviousArticles extends LoadingButton {
  constructor() {
    super();
    this.loadButton = this;
  }

  connectedCallback() {
    this.addEventListener("click", () => {
      this.loadPreviousArticles();
    });
  }

  loadPreviousArticles() {
    this.classList.add("loading");
    this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

    const currentPageIndex = parseInt(this.dataset.pageIndex);
    const previousPageIndex = currentPageIndex - 1;

    let url = window.location.href;
    url = url.split("?")[0];
    url = url.replace(/&?page=\d+/, "");
    url = url + `?page=${previousPageIndex}`;

    this.dataset.pageIndex = previousPageIndex;

    this.fetchItems(url, true);
  }
}

customElements.define("load-previous-articles", LoadingPreviousArticles);
